<template>
  <label class="toggle-option">
    <span class="label">
      <slot />
    </span>

    <span class="switch">
      <input
        ref="inputEl"
        :checked="modelValue"
        type="checkbox"
        @input="onInput"
      >
      <span class="slider" />
    </span>
  </label>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],
  setup: (props, { emit }) => {
    const inputEl = ref<HTMLInputElement>();

    const onInput = () => {
      if (!inputEl.value) return;

      emit('update:modelValue', inputEl.value.checked);
      inputEl.value.checked = props.modelValue;
    };

    return { inputEl, onInput };
  },
});
</script>

<style scoped lang="scss">
$size: 16px;
$padding: 2px;

$height: $size + $padding * 2;
$width: $height + $size;

.toggle-option {
  display: flex;
  align-items: flex-start;
  gap: .5rem;
}

.label {
  flex: 1 1 auto;
}

.switch {
  flex: 0 0 auto;
  position: relative;
  display: inline-block;
  width: $width;
  height: $height;

  input {
    opacity: 0;
  }
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #CCC;
  transition: all .4s ease-in-out;
  border-radius: $height;
  outline: 1px dashed transparent;
  outline-offset: 2px;

  &:before {
    position: absolute;
    content: '';
    height: $size;
    width: $size;
    left: $padding;
    bottom: $padding;
    background-color: white;
    transition: all .10s ease-in-out;
    border-radius: 50%;
  }
}

input {
  &:checked + .slider {
    background-color: var(--acerto-primary-color);
  }

  &:focus + .slider {
    outline-color: var(--acerto-primary-color);
  }

  &:checked + .slider:before {
    transform: translateX($size);
  }
}
</style>
